import * as React from 'react';

interface Props {
  fillColor?: string;
  strokeColor?: string;
  className?: string;
}

const CircleSparklesIcon: React.FC<Props> = ({
  fillColor = '#187A90',
  strokeColor = '#B4D9E0',
  className,
}) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="1.77662"
        y="1.77662"
        width="26.4457"
        height="26.4457"
        rx="13.2228"
        fill={fillColor}
      />
      <rect
        x="1.77662"
        y="1.77662"
        width="26.4457"
        height="26.4457"
        rx="13.2228"
        stroke={strokeColor}
        strokeWidth="1.93505"
      />
      <path
        d="M13.2262 10.2699L14.7044 13.5219L17.9563 15L14.7044 16.4782L13.2262 19.7301L11.7481 16.4782L8.49609 15L11.7481 13.5219L13.2262 10.2699ZM13.2262 13.1257L12.635 14.4087L11.3519 15L12.635 15.5913L13.2262 16.8743L13.8175 15.5913L15.1005 15L13.8175 14.4087L13.2262 13.1257ZM19.1389 13.2262L18.3939 11.6062L16.7738 10.8612L18.3939 10.1221L19.1389 8.49609L19.878 10.1221L21.5039 10.8612L19.878 11.6062L19.1389 13.2262ZM19.1389 21.5039L18.3939 19.8839L16.7738 19.1389L18.3939 18.3998L19.1389 16.7738L19.878 18.3998L21.5039 19.1389L19.878 19.8839L19.1389 21.5039Z"
        fill="white"
      />
    </svg>
  );
};

export default CircleSparklesIcon;
